/** Service for fetching merchant warehouses and exchange zones options */
import { injectable } from "inversify";
import { IApiResponse, IHttpService } from "../http-service";
import { TYPE, rootContainer } from "../container/root";
import {ICountryZone} from "../../models/User";
import {IPlatformLocation} from "../../pages/return-methods/return-method-types";

/** API response for merchant warehouses and exchange zones options */
export interface IMerchantWarehousesAndZones {
    merchant_warehouses: IPlatformLocation[];
    exchange_zones_options: ICountryZone[];
}

@injectable()
class MerchantWarehousesZonesService {

    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    public async getMerchantWarehousesAndZones(): Promise<IMerchantWarehousesAndZones> {
        const response = await this.httpService.get<IApiResponse<IMerchantWarehousesAndZones>>(
            `/rms-api/user/settings/merchant-warehouses-and-zones`
        );
        return response.payload;
    }
}

export default MerchantWarehousesZonesService;

